import * as types from "../consts";
import { SignupReducer } from "../interfaces";

const initState = {
  isSignupOk: false,
  signupError: {}
};

export default function signupReducer(state = initState, action: SignupReducer) {
  switch (action.type) {
    case types.POST_CREATE_TENANT_REQUEST: {
      return { ...state, isSignupOk: false };
    }
    case types.POST_CREATE_TENANT_SUCCESS: {
      return { ...state, signup: action.response, isSignupOk: true };
    }
    case types.POST_CREATE_TENANT_ERROR: {
      return { ...state, isSignupOk: false, signupError: action.error };
    }

    default: {
      return { ...state };
    }
  }
}
